import React from 'react';
import PropTypes from 'prop-types';
import FormErrors from "./FormErrors";
import DestinationSelect from "./DestinationSelect";
import CustomDataCheckbox from "./CustomDataCheckbox";

export default class MoveForm extends React.Component {
  static propTypes = {
    updateForm:       PropTypes.func.isRequired,
    virtualLineMover: PropTypes.object.isRequired,
    children:         PropTypes.node
  };

  async updateAdvertiserCampaign(event) {
    const { virtualLineMover, updateForm } = this.props;
    await virtualLineMover.udpateAdvertiserCampaign(event);
    updateForm(virtualLineMover);
  }

  async updateAffiliateCampaign(event) {
    const { virtualLineMover, updateForm } = this.props;
    await virtualLineMover.updateAffiliateId(event);
    updateForm(virtualLineMover);
  }

  render() {
    const { virtualLineMover, children } = this.props;

    return (
      <div style={{ paddingBottom: "5px", paddingTop: "7px" }}>
        <FormErrors errors={virtualLineMover.headerErrors()} />
        <form>
          {children}
          <DestinationSelect
            virtualLineMover={virtualLineMover}
            updateAdvertiserCampaign={this.updateAdvertiserCampaign.bind(this)}
            updateAffiliateCampaign={this.updateAffiliateCampaign.bind(this)}
          />
          {
            virtualLineMover.customDataEnabled &&
            <CustomDataCheckbox
              moveCustomData={virtualLineMover.moveCustomData}
              toggleCustomData={this.toggleCustomData.bind(this)}
            />
          }
        </form>
      </div>
    );
  }

  toggleCustomData() {
    this.props.virtualLineMover.moveCustomData = !this.props.virtualLineMover.moveCustomData;
    this.props.updateForm(this.props.virtualLineMover);
  }
}
